import React, { useState, useEffect, useContext, createContext } from "react";
import axios from "axios";
import { LanguageContext } from "../Component/LanguageContext/LanguageContext";
import { useParams } from "react-router-dom";

export const CheckoutPaymentContext = createContext();

export const CheckoutPaymentContextProvider = ({ children }) => {
  const [checkoutPaymentContextDetails, setCheckoutPaymentContextDetails] =
    useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { paymentId} = useParams()
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
  const { language } = useContext(LanguageContext);

  const fetchPaymentContextDetails = async (langParam) => {
    try {
      // Get the course ID from the URL parameter
      const courseId = paymentId;
      if (!courseId) {
        setError('No course ID provided');
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `${marketingBackendUrl}/maflam/get-maflam-pricing-details?lang=${langParam}&_id=${courseId}`
      );

      setCheckoutPaymentContextDetails(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching payment details:', err);
      setError(err.message || 'Failed to fetch payment details');
      setLoading(false);
    }
  };


  useEffect(() => {
    if (paymentId) {
      const langParam = language === "ar" ? 0 : 1;
      fetchPaymentContextDetails(langParam);
    }
  }, [language, paymentId]);

  // useEffect(() => {
  //   const langParam = language === "ar" ? 0 : 1;
  //   fetchPaymentContextDetails(langParam);
  // }, [language,paymentId]);

  return (
    <CheckoutPaymentContext.Provider
      value={{ checkoutPaymentContextDetails, loading, error }}
    >
      {children}
    </CheckoutPaymentContext.Provider>
  );
};
